import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import CreationTemplate from './CreationTemplateComponent';
import actions from '../actions';
import coreActions from '../../../core/actions';

const allActions = { ...coreActions, ...actions };

const mapStateToProps = (state, props) => ({
  config: state.config,
  ...state.creationSettings,
  parentLocation: state.newProduct.parentLocation,
  templates: state.creationSettingsTemplates,
  runtimeConfig: props.runtimeConfig,
});

const mapDispatchToProps = (dispatch) => ({ actions: bindActionCreators(allActions, dispatch) });

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(CreationTemplate);
